<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="webhook-url">
            URL de destino
            <InfoIcon size="1.1x" class="icon hint ml-1" v-tooltip.bottom="hints.url"/>
          </label>
          <input
            id="webhook-url"
            v-model="currentWebhook.url"
            class="form-control"
            placeholder="https://seu-sistema.com.br/webhooks/brobot"
          >
        </div>

        <div class="form-group">
          <label for="webhook-description">
            Descrição
            <InfoIcon size="1.1x" class="icon hint ml-1" v-tooltip.bottom="hints.description"/>
          </label>
          <input id="webhook-description" v-model="currentWebhook.description" class="form-control">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>
            Eventos
            <InfoIcon size="1.1x" class="icon hint ml-1" v-tooltip.bottom="hints.events"/>
          </label>
          <div v-for="event in availableEvents" :key="event.event">
            <BkpsCheckBox class="pl-2" :value="checked(event.event)" @input="toggleEvent(event.event, $event)">
              {{ event.label }}
              <small class="ml-1">({{ event.event }})</small>
            </BkpsCheckBox>
          </div>
        </div>

        <div class="form-group">
          <label>Opções</label>

          <div class="option d-flex align-items-center mb-2">
            <BkpsCheckBox class="pl-2" :value="currentWebhook.includeXml" @input="currentWebhook.includeXml = $event">
              Enviar o XML da nota junto do evento
            </BkpsCheckBox>
            <InfoIcon size="1.1x" class="icon hint ml-1" v-tooltip.bottom="hints.includeXml"/>
          </div>

          <div v-if="currentWebhook.id" class="option d-flex align-items-center mb-2">
            <BkpsCheckBox class="pl-2" :value="currentWebhook.rotateSecret" @input="currentWebhook.rotateSecret = $event">
              Gerar um novo secret ao salvar
            </BkpsCheckBox>
            <InfoIcon size="1.1x" class="icon hint ml-1" v-tooltip.bottom="hints.rotateSecret"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="$emit('cancel')">Cancelar</button>
        <button class="btn btn-primary" :disabled="disabledSave" @click="save">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import ModelMapper from '@/mixins/ModelMapper'
  import { InfoIcon } from 'vue-feather-icons'

  export default {
    components: { BkpsCheckBox, InfoIcon },
    computed: {
      currentAxios() {
        return this.axios.v3
      },
      disabledSave() {
        return !this.currentWebhook.url || (this.currentWebhook.events || []).length === 0
      }
    },
    created() {
      this.currentWebhook = { includeXml: false, rotateSecret: false, events: [], ...this.webhook }
    },
    data() {
      return {
        currentWebhook: {},
        hints: {
          description: 'Serve só para você identificar este webhook na lista. Não é enviado ao seu sistema.',
          events: 'Marque o que deve disparar uma chamada para a sua URL. O nome entre parênteses é o que vai no header X-Brobot-Event-Type.',
          includeXml: 'Marcado, o XML da nota vai no próprio evento. Desmarcado, o evento leva só os dados da nota e o XML é buscado na API quando você precisar.',
          rotateSecret: 'Ao salvar, o secret atual deixa de valer na hora e o novo é exibido uma única vez.',
          url: 'Precisa ser https e não pode apontar para endereço interno da sua rede.'
        },
        modelPath: 'webhooks',
        nameModel: 'Webhook'
      }
    },
    methods: {
      checked(event) {
        return (this.currentWebhook.events || []).includes(event)
      },
      save() {
        const isNew = !this.currentWebhook.id

        this.asyncTemplateSave(this.currentWebhook, {
          after: ({ model }) => {
            this.$notify.add(isNew ? 'Webhook cadastrado com sucesso!' : 'Webhook atualizado com sucesso!')
            this.$emit('saved')
            this.$emit('cancel')
            if (model.secret) this.$emit('created', model.secret)
          }
        })
      },
      toggleEvent(event, checked) {
        const events = [...(this.currentWebhook.events || [])]
        const index = events.indexOf(event)

        if (checked && index < 0)
          events.push(event)
        else if (!checked && index >= 0)
          events.splice(index, 1)

        this.$set(this.currentWebhook, 'events', events)
      }
    },
    mixins: [ModelMapper],
    name: 'WebhookForm',
    props: {
      availableEvents: { default: () => [], type: Array },
      webhook: { default: () => ({}), type: Object }
    },
    watch: {
      webhook(value) {
        this.currentWebhook = { includeXml: false, rotateSecret: false, events: [], ...value }
      }
    }
  }
</script>

<style scoped>
  .hint {
    cursor: help;
  }

  .option .checkbox {
    margin-bottom: 0;
    padding-bottom: 0;
  }
</style>
